import {useContext, useEffect, useState} from "react";
import './cab.css';
import { PaymentContext } from "../Payments/PaymentContext";
import { useNavigate } from "react-router";
import {Button, Typography} from '@mui/material';

export default function BookCabs(){
    const [dataObtained, setDataObtained] = useState([]);
    const [date, setDate] = useState(new Date());
    const {setPrice, setSurcharge} = useContext(PaymentContext);
    const navigate = useNavigate();
    const [loader, setLoader] = useState('true');

    useEffect(()=>{
        window.scrollTo(0, 0);
        const url = 'https://mocki.io/v1/5e95ad40-079a-4e80-9338-2f50d7fd1926';
        fetch(url)
    .then((res)=>{
        res.json()
        .then((data)=>{
            setDataObtained(data);
            setLoader(false);
        })
    })
    } , [])
    return (
       <>
        {loader ? <>
        <div className="loader">
           <img src="/loader.gif" style={{width:'100px', height:'100px'}}/> 
        </div></> : 
        <>
            <h3 style={{marginLeft: '16vw'}}>Available Cabs</h3>
        <div className="ticket-container">
            {dataObtained.map((el, idx)=>{
                return (
                    <div className="tkt-box" key={idx}>
                        <table>
                            <tr>
                                <td>FROM</td>
                                <td>DEPARTURE</td>
                                <td>PRICE</td>
                            </tr>
                            <tr>
                                <td><Typography
                                variant="h5"
                                lineHeight='1'
                                >{el.from}</Typography></td>
                                <td><h4>{el.departure.departureTime}|{date.getDate()}-{date.getMonth()}-{date.getFullYear()}</h4></td>
                                <td>{el.price}</td>
                            </tr>
                            <tr>
                                <td>To</td>
                                <td>RETURN</td>
                                <td>VIA</td>
                            </tr>
                            <tr>
                                <td><Typography
                                variant="h5"
                                lineHeight='1'
                                >{el.to}</Typography></td>
                                <td><h4>{el.return.returnTime}|{date.getDate()}-{date.getMonth()}-{date.getFullYear()}</h4></td>
                                <td>{el.via.length ? el.via[0] : "N/A"}</td>
                            </tr>
                            <tr>
                                <td>Cab Provider:</td>
                                <td>Duration:</td>
                            </tr>
                            <tr>
                                <td><h4>{el.airlineName}</h4></td>
                                <td><h4>{el.duration}</h4></td>
                            </tr>
                        </table>
                        <Button 
                        variant="contained"
                        sx={{float:'right', marginRight:'20px', marginBottom:'20px'}} 
                        id={el.price} 
                        onClick={(e)=>{
                            e.persist();
                            setPrice(parseInt(e.currentTarget.id));
                            setSurcharge(parseInt(e.currentTarget.id)*0.25);
                            navigate('/payments');
                        }
                        }>BOOK</Button>
                    </div>
                )
            })}
        </div>
        </>
        }
       </> 
    )
}